// extracted by mini-css-extract-plugin
module.exports = {"container":"RemoveExpirationActionButtons_container__3PROD","buttons":"RemoveExpirationActionButtons_buttons__2F_it"};